/**
 * Add a style tag to the iframe head.
 *
 * @param {Document} document to target (required)
 * @param {object} attributes html attributes to apply to the style/link tag, including href (optional)
 * @param {string} stylesContent actual css content to be wrapped by a style tag (optional)
 */
const addStyles = async (
  targetDocument,
  attributes,
  stylesContent = null,
  prepend = false,
) => {
  const element = targetDocument.createElement(
    stylesContent ? 'style' : 'link',
  );

  const stylesLoadPromise = new Promise((resolve) => {
    element.onload = resolve;
    element.onerror = resolve; // we can't let one little failed fetch take down the whole eReader
  });

  for (let attribute in attributes) {
    element.setAttribute(attribute, attributes[attribute]);
  }

  element.type = 'text/css';
  if (stylesContent) {
    element.append(document.createTextNode(stylesContent));
  } else {
    element.rel = 'stylesheet';
  }

  if (prepend) {
    targetDocument.head.prepend(element);
  } else {
    targetDocument.head.append(element);
  }

  if (element.href) {
    // Wait for stylesheet to load
    await stylesLoadPromise;
  }

  return element;
};

export default addStyles;
